<template>
  <TabPanel value="auto-pilot">
    <FeatureCard
      span="2"
      title="Set your profile on auto-pilot"
      bg-color="secondary"
      color="secondary"
    >
      <VText gutter-bottom>
        Save time managing your bio link with our automation tools.
      </VText>

      <FeatureCardList component="ol">
        <li>Embed Podcast</li>
        <li>Feed links <Badge content="Pro" /></li>
        <li>Image grid auto-sync <Badge content="Pro" /></li>
        <li>Scheduled links <Badge content="Pro" /></li>
      </FeatureCardList>

      <video
        slot="img"
        src="~/assets/videos/home/auto-pilot.mp4"
        loading="lazy"
        type="video/mp4"
        muted
        loop
        playsinline
        style="aspect-ratio: 16 / 9"
      />
    </FeatureCard>
  </TabPanel>
</template>

<script>
import { VText, TabPanel, Badge } from '@campsite-bio/component-lib';

import FeatureCard from '@/components/features/feature-card';
import FeatureCardList from '@/components/features/feature-card-list';

export default {
  components: {
    VText,
    TabPanel,
    Badge,
    FeatureCard,
    FeatureCardList,
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
